import { render, staticRenderFns } from "./PcqEditor.vue?vue&type=template&id=9f8ff144&"
import script from "./PcqEditor.vue?vue&type=script&lang=js&"
export * from "./PcqEditor.vue?vue&type=script&lang=js&"
import style0 from "./PcqEditor.vue?vue&type=style&index=0&id=9f8ff144&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports